export default "__VITE_ASSET__17c8bc2a__"